import { format } from 'date-fns';
import { getLastOperationDate } from '../api/getLastOperationDate';

type GetOperationDateLimitProps = {
  societyId: string;
  onChangeOperationLimit?: (date: string) => void; // eslint-disable-line
  onChangeLastOperationDate?: (date: string) => void; // eslint-disable-line
};

const defaultLastDate = '1990-01-01T00:00';
const defaultLastDateShort = '1990-01-01';

export const getOperationDateLimit = async ({
  societyId,
  onChangeOperationLimit,
  onChangeLastOperationDate,
}: GetOperationDateLimitProps) => {
  if (!societyId) {
    return;
  }

  try {
    const lastOperationDate = (await getLastOperationDate(societyId)) as string;

    const lastDate = format(new Date(lastOperationDate), "yyyy-MM-dd'T'HH:mm");
    const dateLimit = format(new Date(lastOperationDate), 'yyyy-MM-dd');

    if (onChangeOperationLimit) {
      onChangeOperationLimit(dateLimit);
    }

    if (onChangeLastOperationDate) {
      onChangeLastOperationDate(lastDate || defaultLastDate);
    }
  } catch {
    if (onChangeOperationLimit) {
      onChangeOperationLimit(defaultLastDateShort);
    }
    if (onChangeLastOperationDate) {
      onChangeLastOperationDate(defaultLastDate);
    }
  }
};
